import React from 'react';
import { render } from 'react-dom';
import { ready } from 'core-utilities';
import { rootElementId } from './app.config';
import App from './App';

ready(() => {
  render(<App />, document.getElementById(rootElementId));
});
